// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--f71dc";
export var carouselContainer = "styles-module--carouselContainer--37259";
export var carouselItem = "styles-module--carouselItem--612d9";
export var container = "styles-module--container--54268";
export var desktop = "1340px";
export var dockBottom = "styles-module--dockBottom--09c02";
export var feature = "styles-module--feature--5b939";
export var features = "styles-module--features--3ea23";
export var flexContainer = "styles-module--flexContainer--c8b50";
export var giant = "2200px";
export var heading = "styles-module--heading--4437f";
export var hoverWiggle = "styles-module--hover-wiggle--bbbd3";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mediaContainer = "styles-module--mediaContainer--90fdd";
export var mediaOnRight = "styles-module--mediaOnRight--7fe71";
export var mobile = "400px";
export var padding = "styles-module--padding--3f17d";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var square = "styles-module--square--f7083";
export var tablet = "769px";
export var textArray = "styles-module--textArray--a1f55";
export var textBlock = "styles-module--textBlock--c64ee";
export var textContainer = "styles-module--textContainer--c0f73";
export var video = "styles-module--video--20f88";